import { openUnavailableSources } from "@mirage/service-fss-bridge";
import type { UnavailableSource } from "@mirage/service-fss-bridge/service/bridge_types";
import i18n from "@mirage/translations";
import { useCallback } from "react";

import { Banner } from "@dropbox/dig-components/banner";
import { Link } from "@mirage/link/Link";
import css from "./UnavailableSourcesBanner.module.css";

export const UnavailableSourcesBanner = ({
  unavailableSources,
}: {
  unavailableSources: UnavailableSource[];
}) => {
  const onClick = useCallback(() => {
    openUnavailableSources(unavailableSources);
  }, [unavailableSources]);

  return (
    <Banner className={css.banner} withCloseButton={i18n.t("close")}>
      <Banner.Message>
        <Link className={css.link} href="#" onOpen={onClick}>
          {i18n.t("unavailable_sources_banner", {
            count: unavailableSources.length,
          })}
        </Link>
      </Banner.Message>
    </Banner>
  );
};
